import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            Helene L. Köppel - Autorin
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#about" className="page-scroll">
                Vita
              </a>
            </li>
            <li>
              <a href="#thriller" className="page-scroll">
                Thriller
              </a>
            </li>
            <li>
              <a href="#historische" className="page-scroll">
                Historische Romane
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                Leserstimmen
              </a>
            </li>
            <li>
              <a href="#impressum" className="page-scroll">
                Impressum
              </a>
            </li>
            <li>
              <a href="#datenschutz" className="page-scroll">
                Datenschutz
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
